import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey } from './useConceptDeterminationMethods';

// Config
import { uiConfig } from '../../../conf/conceptDeterminationMethods';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.CONCEPT_DETERMINATION_METHOD);

export const useDeleteConceptDeterminationMethod = ({ crudConfig, sessionToken, onSuccessCb, onErrorCb }) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: (codeId) => Client.delete(sessionToken, codeId),
        onSuccess: (data) => {
            updateCacheArray({
                queryKey: getQueryKey(),
                action: CACHE_ACTIONS.REMOVE,
                primaryKey: uiConfig.primaryKey,
                data
            });
            onSuccessCb?.();
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        refetchOnWindowFocus: false
    });
};
